import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { AfTranslateDirective } from "../../modules/translate/directive/af-translate.directive";

@Component({
  selector: 'migration-data',
  templateUrl: './migration-data.component.html',
  standalone: true,
  imports: [AfTranslateDirective]
})
export class MigrationDataComponent implements OnInit {
  constructor(private translate:AfTranslateFactory,
    private dialogRef: DynamicDialogRef<MigrationDataComponent>,
    private dialogConfig: DynamicDialogConfig){}

  isClient: boolean = this.dialogConfig.data.isClient;
  type: string = this.dialogConfig.data.type;
  migrationData: any = {};

  ngOnInit(): void {
    this.setTranslations();
  }

  private setTranslations(): void {
    const that = this.migrationData;
    let clientSuffix: string = this.isClient ? '-client' : '';
    if(!this.isClient && this.type === 'contacts'){
     clientSuffix = '-contacts';
    }

    that.headerInfo = this.translate.instant("migration-data.title-info-migration");
    that.templateDesc = this.translate.instant("migration-data.download-template-info" + clientSuffix);
    that.importTitle = this.translate.instant("migration-data.import-data-migration");
    that.importDesc = this.translate.instant("migration-data.import-data-info" + clientSuffix)
    that.exportTitle = this.translate.instant("migration-data.export-data-migration");
    that.exportDesc = this.translate.instant("migration-data.export-data-info" + clientSuffix);
  }

  handleAccept(option: string) {
    this.dialogRef.close({result: 'ok', optionSelect: option});
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }
}
